<template>
  <v-container fluid>
    <v-data-table-server
      :headers="headers"
      :items="gimProductLines"
      :search="search"
      density="compact"
      :items-length="totalItems"
      :loading="loadingDatatables"
      @update:sortBy="toSort"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            density="compact"
            :label="this.$t('search')"
            class="pl-2"
            :prepend-inner-icon="mdiMagnify"
            @update:modelValue="toSearchBack"
            variant="solo-filled"
            flat
            hide-details
            single-line
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            variant="elevated"
            class="mb-2 text-white mr-3"
            :prepend-icon="mdiAccountPlus"
            color="#ffb300"
            @click="openDialog"
            dark
          >
            {{ $t("admin.new-gim-product-line") }}
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon class="me-2" size="small" @click="editItem(item)">
          {{ mdiPencil }}
        </v-icon>
        <v-icon size="small" @click="deleteItem(item)">
          {{ mdiDelete }}
        </v-icon>
      </template>

      <template v-slot:bottom>
        <pagination-dynamic :store="'gimProductLines'"></pagination-dynamic>
      </template>
    </v-data-table-server>
    <add-edit-gim-product-line
      :modelDialog="gimProductLineDialog"
      @close="gimProductLineDialog = false"
    ></add-edit-gim-product-line>
  </v-container>
</template>

<script>
import { mdiPencil, mdiDelete, mdiMagnify, mdiAccountPlus } from "@mdi/js";
import PaginationDynamic from "@/components/PaginationDynamic.vue";
import AddEditGimProductLine from "./admin/AddEditGimProductLine.vue";
import paginate from "@/mixins/paginations";
import { mapState } from "vuex";

export default {
  name: "GimProductLineAdmin",
  components: { AddEditGimProductLine, PaginationDynamic },
  mixins: [paginate],
  data() {
    return {
      mdiAccountPlus,
      mdiMagnify,
      mdiPencil,
      mdiDelete,
      dialog: false,
      dialogDelete: false,
      gimProductLineDialog: false,
      itemsPerPage: 15,
      page: 1,
      headers: [
        { title: "Nom", key: "name" },
        { title: "Actions", key: "actions", sortable: false, align: "end" }
      ]
    };
  },
  computed: {
    ...mapState({
      gimProductLines: (state) => state.gimProductLines.items,
      loadingDatatables: (state) => state.loadingTables,
      totalItems: (state) => state.paginations.totalCount,
      editedId: (state) => state.gimProductLines.editedId
    }),
    pageCount() {
      return Math.ceil(this.gimProductLines.length / this.itemsPerPage);
    },
    search: {
      get() {
        return this.$store.state.paginations.search;
      },
      set(value) {
        this.$store.commit("paginations/setSearch", value);
      }
    }
  },
  methods: {
    toSort(item) {
      this.sortBy(item, "gimProductLines");
    },
    toSearchBack(value, time = 500) {
      this.searchBack(value, time, "gimProductLines");
    },
    openDialog() {
      this.$store.commit("gimProductLines/setEditedId", -1);
      this.$store.commit(
        "gimProductLines/setEditedItem",
        Object.assign({}, {})
      );
      this.gimProductLineDialog = true;
    },
    editItem(item) {
      this.$store.commit("gimProductLines/setEditedId", item.id);
      this.$store.commit(
        "gimProductLines/setEditedItem",
        Object.assign({}, item)
      );
      this.gimProductLineDialog = true;
    },
    deleteItem(item) {
      if (confirm(this.$t("alert.delete.gim-product-line"))) {
        this.$store
          .dispatch("gimProductLines/deleteItem", item.id)
          .then(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.success.gim-product-line-delete"),
              color: "success"
            });
            this.toSearchBack(this.search, 500, "gimProductLines");
          })
          .catch(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.error.gim-product-line-delete"),
              color: "error"
            });
          });
      }
    }
  }
};
</script>
